module.exports = __webpack_public_path__ + "img/pointer.8896e2d0.svg";